const ADMINS = "/admins"
const DATA_EXPORT = "/data-export"

export { ADMINS, DATA_EXPORT }
